import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { verifySchema } from "../schemas/schemas";
import { useVerifyMutation, useResendCodeMutation } from '../api/mutations/signIn.mutation';
import { Logo } from "../assets/imageAssets";
import Input from "../components/Input";
import Button from "../components/Button";
import { useLocation } from 'react-router-dom';

const Verify = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get("email");

    const {
        handleSubmit,
        register,
        formState: { errors },
    } = useForm({
        mode: 'onChange',
        reValidateMode: 'onChange',
        shouldFocusError: true,
        shouldUseNativeValidation: false,
        resolver: yupResolver(verifySchema),
    });
    const { mutate } = useVerifyMutation();
    const { mutate: mutateResend } = useResendCodeMutation();
    const onSubmit = (data) => {
        mutate({ ...data, email });
    };
    const onResend = (data) => {
        mutateResend({ email });
    };

    return (
        <div className="login">
            <div className="login__content flex flex-align-center flex-direction-col text-center">
                <div className="logo">
                    <img src={Logo} alt="Logo" />
                </div>
                <div>
                    <h1 className='mb-12'>Verify your email</h1>
                    <p className='text-min text-color-grey'>{email ? `Verification code sent to ${email}` : ''}</p>
                </div>
                <form className='full-width' onSubmit={handleSubmit(onSubmit)}>
                    <Input
                        label='Code'
                        placeholder='Enter code'
                        id='code'
                        className={'mb-20'}
                        register={{ ...register('code') }}
                        error={errors?.code}
                        errorMessage={errors?.code?.message}
                    />
                    <Button 
                        text='Verify' 
                        className={'full-width mb-16'}
                    />
                </form>
                <button onClick={onResend}>Resend code</button>
            </div>
        </div>
    );
}

export default Verify;